import api from './apiService';
import apiRoutes from './apiRoutes';

// ---- Registration ----
export const createNewAccountAsync = async (payload) => {
  try {
    const response = await api.post(apiRoutes.createAccount, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

// ---- Forgot password (anonymous) ----
// New password is emailed to the employee. Throws the axios error (use error.response.status).
export const resetPasswordAsync = async ({ idNumber, email }) => {
  try {
    const response = await api.post(apiRoutes.resetPassword, { idNumber, email });
    return response;
  } catch (error) {
    throw error;
  }
};

// employee/profile — token-scoped in V2 (no id needed; arg kept for call-site compatibility).
// Add legacy aliases the profile components expect (V2 profile has no positions).
export const getEmpProfile = async () => {
  try {
    const response = await api.get(apiRoutes.getEmployeeProfile);
    const p = response.result || {};
    return {
      ...p,
      id: p.employeeId,
      // V2 profile now returns positions[]; map to the legacy deptPos shape the UI renders.
      deptPos: (p.positions || []).map((pos) => ({
        deptPosId: pos.employeePositionId,
        deptName: pos.departmentName,
        posTitle: pos.positionTitle,
      })),
      qualification: p.qualificationName,
      nationality: p.nationalityName,
    };
  } catch (error) {
    throw error;
  }
};

// Mark a profile-update request as read (V2: PUT .../{id}/mark-read, empty 200).
export const updateProfileUpdateRequestAsync = async (requestId) => {
  try {
    await api.put(apiRoutes.markProfileUpdateRequestRead(requestId));
    return true;
  } catch (error) {
    throw error;
  }
};

// List the employee's profile-update requests. V2 returns { items: [...] }; unwrap to the array.
export const getProfileUpdateRequestAsync = async (empId, status) => {
  try {
    const response = await api.get(apiRoutes.getProfileUpdateRequest, {
      params: { status },
    });
    return response.result.items || [];
  } catch (error) {
    throw error;
  }
};

// Submit a profile-update request. V2 returns the new request id (number).
export const requestProfileUpdateAsync = async (payload) => {
  try {
    const response = await api.post(apiRoutes.requestProfileUpdate, payload);
    return { result: response.result, message: 'تم إرسال طلب التعديل بنجاح' };
  } catch (error) {
    throw error;
  }
};

// ---- Lookups (V2 returns { items: [{ id, name }] }; map back to legacy field names) ----
export const getAllNationalityAsync = async () => {
  try {
    const response = await api.get(apiRoutes.getAllNationality);
    return (response.result.items || []).map((x) => ({ nationalityId: x.id, name: x.name }));
  } catch (error) {
    throw error;
  }
};

export const getQualificationAsync = async () => {
  try {
    const response = await api.get(apiRoutes.getAllQualifications);
    return (response.result.items || []).map((x) => ({
      qualificationId: x.id,
      qualificationName: x.name,
    }));
  } catch (error) {
    throw error;
  }
};

export const getExactSpecializationsAsync = async () => {
  try {
    const response = await api.get(apiRoutes.getExactSpecializations);
    return (response.result.items || []).map((x) => ({
      exactSpecializationId: x.id,
      name: x.name,
    }));
  } catch (error) {
    throw error;
  }
};

// For updating password (must be logged in). V2: POST auth/me/change-password { oldPassword, newPassword }.
export const updatePasswordAsync = async (payload) => {
  try {
    const response = await api.post(apiRoutes.changePassword, payload);
    return response.result;
  } catch (error) {
    throw error;
  }
};
